/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleAnalyticsAttributionShadowSummaryData } from './GoogleAnalyticsAttributionShadowSummaryData';
import {
    GoogleAnalyticsAttributionShadowSummaryDataFromJSON,
    GoogleAnalyticsAttributionShadowSummaryDataFromJSONTyped,
    GoogleAnalyticsAttributionShadowSummaryDataToJSON,
    GoogleAnalyticsAttributionShadowSummaryDataToJSONTyped,
} from './GoogleAnalyticsAttributionShadowSummaryData';
import type { GoogleAnalyticsAttributionShadowOrderData } from './GoogleAnalyticsAttributionShadowOrderData';
import {
    GoogleAnalyticsAttributionShadowOrderDataFromJSON,
    GoogleAnalyticsAttributionShadowOrderDataFromJSONTyped,
    GoogleAnalyticsAttributionShadowOrderDataToJSON,
    GoogleAnalyticsAttributionShadowOrderDataToJSONTyped,
} from './GoogleAnalyticsAttributionShadowOrderData';

/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionShadowPreviewData
 */
export interface GoogleAnalyticsAttributionShadowPreviewData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowPreviewData
     */
    since?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowPreviewData
     */
    until?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleAnalyticsAttributionShadowPreviewData
     */
    unmatchedGoogleAnalyticsTransactions?: number;
    /**
     * 
     * @type {Array<GoogleAnalyticsAttributionShadowSummaryData>}
     * @memberof GoogleAnalyticsAttributionShadowPreviewData
     */
    summary?: Array<GoogleAnalyticsAttributionShadowSummaryData>;
    /**
     * 
     * @type {Array<GoogleAnalyticsAttributionShadowOrderData>}
     * @memberof GoogleAnalyticsAttributionShadowPreviewData
     */
    orders?: Array<GoogleAnalyticsAttributionShadowOrderData>;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionShadowPreviewData interface.
 */
export function instanceOfGoogleAnalyticsAttributionShadowPreviewData(value: object): value is GoogleAnalyticsAttributionShadowPreviewData {
    return true;
}

export function GoogleAnalyticsAttributionShadowPreviewDataFromJSON(json: any): GoogleAnalyticsAttributionShadowPreviewData {
    return GoogleAnalyticsAttributionShadowPreviewDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowPreviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionShadowPreviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'unmatchedGoogleAnalyticsTransactions': json['unmatchedGoogleAnalyticsTransactions'] == null ? undefined : json['unmatchedGoogleAnalyticsTransactions'],
        'summary': json['summary'] == null ? undefined : ((json['summary'] as Array<any>).map(GoogleAnalyticsAttributionShadowSummaryDataFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(GoogleAnalyticsAttributionShadowOrderDataFromJSON)),
    };
}

export function GoogleAnalyticsAttributionShadowPreviewDataToJSON(json: any): GoogleAnalyticsAttributionShadowPreviewData {
    return GoogleAnalyticsAttributionShadowPreviewDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowPreviewDataToJSONTyped(value?: GoogleAnalyticsAttributionShadowPreviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'unmatchedGoogleAnalyticsTransactions': value['unmatchedGoogleAnalyticsTransactions'],
        'summary': value['summary'] == null ? undefined : ((value['summary'] as Array<any>).map(GoogleAnalyticsAttributionShadowSummaryDataToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(GoogleAnalyticsAttributionShadowOrderDataToJSON)),
    };
}

